import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';

export default class ProjEditPtypeDom extends React.Component {
    constructor(props) {
        super(props);

        // this.state = {
        //     value: props.value
        // };
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        console.log(event.target.value);
        this.props.onChange(this.props.dataKey, event.target.value);
    }

    render() {
        const { isDisabled, data, value } = this.props;
        // const { value } = this.state;

        const tmp = [];
        tmp.push(<option key="empty">請選擇</option>);
        for (const [key, val] of Object.entries(data.options)) {
            tmp.push(<option key={key} value={key}>{val}</option>);
        }

        if (isDisabled) {
            return (
                <Col className="mb-2">
                    <label>{data.name}</label>
                    {/* <input disabled="disabled" className="form-control" type="text" value={value} /> */}
                    <select disabled="disabled" className="form-control" value={value || "empty"} onChange={this.onChange}>
                        {tmp}
                    </select>
                </Col>
            );
        } else {
            return (
                <Col className="mb-2">
                    <label>{data.name}</label>
                    {/* <input className="form-control" type="text" value={value} onChange={this.onChange} /> */}
                    <select className="form-control" value={value || "empty"} onChange={this.onChange}>
                        {tmp}
                    </select>
                </Col>
            );
        }
    }
}